import { Button, Tooltip } from "@material-ui/core";
import moment from "moment";
import React from "react";
import { MatchStatus, RegistrationType } from "../../Base/AdoptionConstants";
import PaginatedTableResults from "../../Base/Components/PaginatedTableResults";
import { searchMatches } from "../../Base/Services/MatchService";
import useAdminContext from "../AdminContextProvider";
export default function MatchSearchResults({ inputSearchCriteria, defaultRowsPerPage, selectedRegistrationId }) {
  const adminContext = useAdminContext();

  function searchMatchesWithoutId(criteria) {
    if (selectedRegistrationId) {
      return searchMatches({ ...criteria, excludeRegistrationId: selectedRegistrationId });
    }
    return searchMatches(criteria);
  }

  const tableHeaders = [
    {
      headerName: "ID",
      getField: (row) => row.matchId,
      sortBy: "matchId",
    },
    {
      headerName: "Create Date",
      getField: (row) => {
        let timeFromNow = moment(row.createdDate).fromNow();
        timeFromNow = timeFromNow.charAt(0).toUpperCase() + timeFromNow.slice(1);
        return (
          <Tooltip title={moment(row.createdDate).format("LLL")}>
            <span>{timeFromNow}</span>
          </Tooltip>
        );
      },
      sortBy: "createdDate",
    },
    {
      headerName: "Adoptee",
      getField: (row) => {
        return `${row.adoptee.registrant.contactInformation.lastName}, ${row.adoptee.registrant.contactInformation.firstName}`;
      },
      sortBy:
        "registrant.contactInformation.lastName,registrant.contactInformation.firstName,registrant.contactInformation.middleName",
    },
    {
      headerName: "Relative",
      getField: (row) => {
        return `${row.relative.registrant.contactInformation.lastName}, ${row.relative.registrant.contactInformation.firstName}`;
      },
      sortBy:
        "registrant.contactInformation.lastName,registrant.contactInformation.firstName,registrant.contactInformation.middleName",
    },

    {
      headerName: "Adoptee Birth Date",
      getField: (row) => {
        return row.adoptee.birthDate
          ? moment(row.adoptee.birthDate).format("LL")
          : row.adoptee.birthDateRangeStart && row.adoptee.birthDateRangeEnd
          ? moment(row.adoptee.birthDateRangeStart).format("LL") +
            " - " +
            moment(row.adoptee.birthDateRangeEnd).format("LL")
          : "-";
      },
      sortBy: "adoptee.birthDate,adoptee.birthDateRangeStart,adoptee.birthDateRangeEnd",
    },
    {
      headerName: "Matched To",
      getField: (row) => RegistrationType[row.relative.registrationType]?.label,
      sortBy: "relative.registrationType",
    },
    {
      headerName: "Matched Status",
      getField: (row) => MatchStatus[row.matchStatus].label,
      sortBy: "matchStatus",
    },
    {
      headerName: "Actions",
      getField: (row) => (
        <>
          <Button variant="contained" color="inherit" size="small" onClick={() => adminContext.openMatchDialog(row)}>
            View Details
          </Button>
        </>
      ),
    },
  ];

  return (
    <PaginatedTableResults
      inputSearchCriteria={inputSearchCriteria}
      tableColumns={tableHeaders}
      getTableResultsFunction={searchMatchesWithoutId}
      defaultRowsPerPage={defaultRowsPerPage}
    />
  );
}
